import type { UseSearchPartsParams } from './types';

export type UseSearchPartsQueryKey = readonly [
  'search',
  'parts',
  UseSearchPartsParams,
];

export const getUseSearchPartsQueryKey = (
  params: UseSearchPartsParams,
): UseSearchPartsQueryKey => ['search', 'parts', params];
